<button mat-button type="button" (click)="toggleModal()" class="linq-opener-button" title="{{buttonTitle}}">
	<mat-icon>history</mat-icon>
	<span *ngIf="!hideButtonText">History</span>
</button>
